export default __webpack_public_path__ + "static/media/search_icon.2c4120a6.svg";